import { render, staticRenderFns } from "./ApplyForDeliveryDialog.vue?vue&type=template&id=59275406&scoped=true"
import script from "./ApplyForDeliveryDialog.vue?vue&type=script&lang=js"
export * from "./ApplyForDeliveryDialog.vue?vue&type=script&lang=js"
import style0 from "./ApplyForDeliveryDialog.vue?vue&type=style&index=0&id=59275406&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59275406",
  null
  
)

export default component.exports